import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateCheckAccess = {
  checkAccess: { data: null, loading: false, error: null },
};

export const checkAccess = createAsyncThunk('user/checkAccess', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/auth/status`, {
      token: localStorage.getItem('accessToken'),
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCheckAccess = {
  [checkAccess.pending]: (state) => {
    state.checkAccess.loading = true;
    state.checkAccess.error = null;
  },
  [checkAccess.fulfilled]: (state, action) => {
    state.checkAccess.loading = false;
    state.checkAccess.data = action.payload;
    state.checkAccess.error = null;
  },
  [checkAccess.rejected]: (state, action) => {
    state.checkAccess.loading = false;
    state.checkAccess.error = action.payload;
  },
};
